/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectVersion, selectProcedureResourceEnabled, selectResource } from './configuration.slice';
import { ThunkStatus } from '../../enums/ThunkStatus';
import { fetchDefaultVersion, fetchResource } from './configuration.thunk';
import { ConfigResourceProps } from '../../enums/ConfigResourceProps';
import { ResourceType } from '../../enums/ResourceType';

/* Configuration hook */
export function useConfiguration(configResource, procedure) {
  const dispatch = useDispatch();
  const version = useSelector(selectVersion);

  const resource = useSelector(state => selectResource(state, configResource.name, procedure));
  const isProcedureResourceEnabled = useSelector(state =>
    selectProcedureResourceEnabled(state, procedure, configResource.name),
  );

  const isResourceAvailable =
    configResource.type !== ResourceType.PROCEDURE_SPECIFIC ||
    (configResource.type === ResourceType.PROCEDURE_SPECIFIC && isProcedureResourceEnabled);

  useEffect(() => {
    if (version.status === ThunkStatus.IDLE && configResource === ConfigResourceProps.GLOBAL_CONFIGURATION) {
      dispatch(fetchDefaultVersion());
    }

    if (version.status === ThunkStatus.SUCCEEDED && resource.status === ThunkStatus.IDLE && isResourceAvailable) {
      dispatch(fetchResource({ configResource, procedure, version: version.value }));
    }
  }, [version, resource]);

  return {
    ready: version.status === ThunkStatus.SUCCEEDED && resource.status === ThunkStatus.SUCCEEDED,
    resource: resource.value,
  };
}
